import { render, staticRenderFns } from "./GalleryImage.vue?vue&type=template&id=2a3daf6a"
import script from "./GalleryImage.vue?vue&type=script&lang=js"
export * from "./GalleryImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports